/// <reference path="../../../../typings/globals/jquery/index.d.ts" />
/**
 * Obsluga wyjatkow
 *
 * @export
 * @class Fixes
 */

export class Fixes {
	constructor() {
		this.fixScrollPositionAfterElementShow = false, // wyjatek korygujacy dziwne zachowanie na androidzie, czyli nagly skok skrolla po spacer.show
		this.fixNaviStuckedElement = false; // wyjatek korygujacy scroll przegladarki przesuwajacy el. stucked pod pasek adresu
		this.fixNaviStuckedElementData = {
			isFixed: false,
			fixUrlBarSpacer: null,
			fixSpacerHeight: 0,
			hiddenTopHeight: 0,
			topBeforeFix: null,
			keyboardAnimationTime: 200
		};
		this.fixIOSBounceTimer;
	}
	// ****************************************************************************************************
	// ANDROID FIX - usuniecie efektu rozjeżdzania się strony po pojawieniu się klawiatury (strona się rozsuwa gora dol bez wywaołania onscroll)
	// ****************************************************************************************************
	addFixScrollPositionAfterElementShow(spacer) {
		var st_before = $(window).scrollTop();
		spacer.show(0, function () {
			window.scrollBy(0, (st_before - $(window).scrollTop()));
		});
	}
	// ****************************************************************************************************
	// IOS FIX - blokada efektu bounce
	// ****************************************************************************************************
	fixIOSBounce() {
		var that = this;
		$('html').css('overflow', 'hidden'); // likwiduje efekt bounce!
		// zabezpieczenie - jesli wystapi efekt bounce, to pozycja html zostanie wyrownana
		that.settings.scrollingElement.on('touchstart', function () {
			clearTimeout(that.fixIOSBounceTimer);
		}).on('touchend', function () {
			that.fixIOSBounceTimer = setTimeout(function () {
				// spr czy jest przesuniecie i jaki jest zoom ratio
				if (window.pageXOffset != 0 && (document.documentElement.clientWidth / window.innerWidth) == 1) {
					window.scrollBy(0 - window.pageXOffset, 0);
				}
			}, 850);
		});
	}
	// ****************************************************************************************************
	// IOS FIX - usuniecie efektu rozjeżdzania się strony po pojawieniu się klawiatury (strona się rozsuwa gora dol bez wywaołania onscroll)
	// ****************************************************************************************************
	addFixNaviStuckedElement() {
		var that = this;
		var data = this.fixNaviStuckedElementData;
		if ( $('#mobileLogo').length ) {
			data.hiddenTopHeight = toolsObj.realHeight($('#mobileLogo'));
		}
		data.fixSpacerHeight = data.hiddenTopHeight;
		data.fixUrlBarSpacer = $('<div id="fixUrlBarSpacer" style="height: 0px"></div>').prependTo('#navi');
		//data.fixUrlBarSpacer = $('fixUrlBarSpacer');
		searchObj.searchInput.on('click', function (event) {
			var top = $(window).scrollTop();
			if (data.topBeforeFix === null) {
				data.topBeforeFix = top; // zapamietanie top
			}
			//$('#mobileLogo').height(0);
			if (!data.isFixed) {
				searchObj.blockHidingMobileSearchPanel(); // dla IOS gdzie focus() nie dziala
				setTimeout(function () {
					data.isFixed = true;
					searchObj.blockHidingMobileSearchPanel();
					if (top >= data.fixSpacerHeight && top <= (data.fixSpacerHeight * 2)) { // 40-80
						data.fixUrlBarSpacer.height(data.fixSpacerHeight * 2 - top);
                        /*data.fixUrlBarSpacer.animate({ height: (data.fixSpacerHeight * 2 - top) }, {
                            queue: false,
                            duration: 20,
                            complete: function(){ that.scrollPageToNaviStuckState(); }
                        });*/
						that.scrollPageToNaviStuckState();
					}
					$('nav a.btn-menu').each(function (i, e) {
						$(e).on('click', function (event) {
							data.isFixed = false;
							data.fixUrlBarSpacer.height(0);
							if (data.isFixed) {
								event.preventDefault();
								setTimeout(function () {
									location.href = $(e).attr('href');
								}, data.keyboardAnimationTime);
							}
						});
					});
					document.addEventListener('focusout', function (e) {
						setTimeout(function () {
							data.isFixed = false;
							data.fixUrlBarSpacer.height(0);
							if (data.topBeforeFix !== null) {
								window.scrollTo(0, data.topBeforeFix); // przywrocenie top
								data.topBeforeFix = null;
							}
						}, data.keyboardAnimationTime); // 185 minimum
					});
				}, data.keyboardAnimationTime); // 185 minimum
			}
		});
	}
	// ****************************************************************************************************
	// IE FIX -
	// ****************************************************************************************************
	addIEFix() {
		String.prototype.includes = function (str) {
			var returnValue = false;
			if (this.indexOf(str) !== -1) {
				returnValue = true;
			}
			return returnValue;
		};
	}
}